export enum fontWeights {
  thin = 100,
  extraLight = 200,
  light = 300,
  regular = 400,
  medium = 500,
  semiBold = 600,
  bold = 700,
  extraBold = 800,
  black = 900,
}

export enum fontStyles {
  normal = 'normal',
  italic = 'italic',
  oblique = 'oblique',
}

const formatMime = (ext: 'woff2' | 'woff' | 'ttf'): string => {
  if (ext === 'ttf') return 'truetype'
  return ext
}

export type Font = {
  fontFamily: string
  fontWeight?: fontWeights
  fontStyle?: fontStyles
  fallback: string
  /** Path under `/fonts/` without extension, e.g. `BbComputer/BB-Regular` */
  srcPath: string
  formats: ('woff2' | 'woff' | 'ttf')[]
}

export const defineFont = (font: Font): string => `
  font-family: "${font.fontFamily}", ${font.fallback || 'sans-serif'};
  font-weight: ${font?.fontWeight || fontWeights.regular};
  font-style: ${font?.fontStyle || fontStyles.normal};
`

export const declareFont = ({ fontFamily, fontWeight, srcPath, formats }: Font): string => {
  const src = formats
    .map((ext) => `url("/fonts/${srcPath}.${ext}") format("${formatMime(ext)}")`)
    .join(',\n        ')

  return `
    @font-face {
      font-family: "${fontFamily}";
      font-display: swap;
      font-weight: ${fontWeight ?? fontWeights.regular};
      src: ${src};
    }
  `
}
